import axios from 'axios'
import { PAGE_INFO } from '@/services/constants';
import AnnounceService from "@/services/api/Announce";
import PageService from "@/services/api/Page";

export default {
    getHeader() {
        return axios.get('/api/secTemplate/getHeader').then(response => {
            return response.data
        })
        // return axios.get('/mock/header.html').then(response => {
        //     return response.data
        //})
    },
    getFooter() {
        return axios.get('/api/secTemplate/getFooter').then(response => {
            return response.data
        })
        //return axios.get('/mock/footer.html').then(response => {
        //    return response.data
        //})
    },
    genListByYear(obj) {
        let result = [];
        let tmp = obj.reduce((r, a) => {
            let announce = { publishedDate: a.publishedDate || null, title: a.title, linkurl: a.announceAttachments || "" }

            r[a.publishedThaiBuddhistYear] = [...r[a.publishedThaiBuddhistYear] || [], announce];


            r[a.publishedThaiBuddhistYear] = r[a.publishedThaiBuddhistYear].filter((item, index, arr) => {
                return arr.findIndex(o => o.title === item.title && o.publishedDate === item.publishedDate) === index;
            })

            return r;
        }, {});
        Object.getOwnPropertyNames(tmp).sort((x, y) => (parseInt(y) - parseInt(x))).forEach(
            function (val, idx, array) {
                result.push({ titleTable: val, topicList: tmp[val].sort((x, y) => (Date.parse(y.publishedDate) - Date.parse(x.publishedDate))) });
            }
        );
        return result;
    },
    genListByTitle(obj, titleStr) {
        let result = [];
        let tmp = obj.reduce((r, a) => {
            r.push({ publishedDate: a.publishedDate || null, title: a.title, linkurl: a.announceAttachments || "" })
            return r;
        }, []);
        result.push({ titleTable: titleStr, topicList: tmp.sort((x, y) => (Date.parse(y.publishedDate) - Date.parse(x.publishedDate))) });
        return result;
    },
    emtObj() {
        return new Promise(function (resolve, reject) {
            resolve({
                pageType: 0,
                pageId: 0,
                titleTab: null,
                title: null,
                beadcrumbSection: null,
                contactSection: null,
                html: null,
                obj: null
            });
        })
    },
    getAboutUs(param) {
        if (!param) return

        let routePage = PAGE_INFO.find(x => x.page.toUpperCase() == param.toUpperCase());
        if (routePage) {
            // procurement
            if (routePage.id === 0) {
                //return axios.get(window.location.origin + '/mock/procurement.html').then(response => {
                //    return {
                //        pageType: 1,
                //        pageId: routePage.id,
                //        titleTab: routePage.titleTab,
                //        title: routePage.title,
                //        beadcrumbSection: routePage.beadcrumbSection,
                //        contactSection: routePage.contactSection,
                //        html: response.data,

                //        obj: null
                //    }
                //})

                return PageService.getById(1).then(data => {
                    return {
                        pageType: 1,
                        pageId: routePage.id,
                        titleTab: routePage.titleTab,
                        title: routePage.title,
                        beadcrumbSection: routePage.beadcrumbSection,
                        contactSection: routePage.contactSection,
                        html: data.content,
                        obj: null
                    }
                })
            }
            else {
                //return AnnounceService.getByAnnounceTypeId(routePage.id)
                return AnnounceService.getByPredicate(routePage.predicate)
                    .then(data => {
                        data = data ?.filter(o => o.isActive) ?.map(o => {
                            if (-1 < ['P1', 'P2', 'D1', 'D2', 'W1', 'W2'].indexOf(o.announceTypeCode)) {
                                o.title = o.announceTypeTitle + ' ' + o.title
                            }

                            return o
                        })

                        //let topic = routePage.id === 5 ? this.genListByTitle(data, routePage.titleTab) : this.genListByYear(data);
                        let topic = this.genListByYear(data)

                        return {
                            pageType: 2,
                            pageId: routePage.id,
                            titleTab: routePage.titleTab,
                            title: routePage.title,
                            beadcrumbSection: routePage.beadcrumbSection,
                            contactSection: routePage.contactSection,
                            html: null,
                            obj: topic
                        }
                    })
            }
        }
        else {
            return this.emtObj().then(emp => emp);
        }
    },
}